<div [ngClass]="{'sidenav': true, 'transform': true, 'expanded': isExpanded}">
    <div [ngClass]="{'toggle': true, 't-expanded': isExpanded}" (click)="toggleSidebar()"><i class="material-icons">{{ isExpanded ? 'arrow_back' : 'arrow_forward'}}</i></div>
    <ul>
        <div *ngFor="let link of links">
            <li><a [routerLink]="link.link" [queryParams]="getQueryParam(link.queryParam) | async" routerLinkActive="active"><i class="material-icons">{{link.icon}}</i><span style="color: white; font-weight: bold;">{{ isExpanded ? link.label : ''}}</span></a></li>
        </div>
    </ul>
</div>